const lineRegExp = new RegExp('\\r?\\n');
const toLines = (text: string | undefined): string[] =>
  text ? text.split(lineRegExp).filter((l) => l.trim().length > 0) : [];

export { toLines };
